module.exports = __webpack_public_path__ + "img/btn_bg_2.421bae4e.png";